import Navbar from '../layout/Navbar';
import Footer from '../layout/Footer';
import ButtonDownload from '../layout/ButtonDowload';

import styles from '../App.module.css'


export default function Download() {

 

    return (


        <div className={styles.backGround}>

            <Navbar />


            <div className={styles.imgBackGround}>
              






                <img src='https://assets-global.website-files.com/60870fec5b198a014ca79bcd/60f6bb72ee342c72331497b1_aplicacao-visual-engenharia-cardapio.jpg' alt='Img' />
               
            </div>




            <Footer />
            
            <img className={styles.listraOpacity} src='https://img.freepik.com/fotos-gratis/superficie-abstrata-e-texturas-de-parede-de-pedra-branca-de-concreta_74190-8189.jpg'/>

            <ButtonDownload/>
        </div>



    )
}